import { createSelector } from "reselect";

import { filterTripCartItems } from "@app/modules/checkout/utils/cart-v2";
import { getAsyncCart } from "@app/modules/results/selectors/state-accessors";

/**
 * @returns {NapiV2TripItem | null} The trip items in the cart. As of today we only have one trip item in the cart.
 */
export const getCartTripItem = createSelector([getAsyncCart], cart => {
  if (!cart) {
    return null;
  }

  return filterTripCartItems(cart.items)[0] ?? null;
});

export const getCartTripItemByTripId = createSelector(
  [getCartTripItem, (_: unknown, trip_id: string) => trip_id],
  (trip_items, trip_id) => {
    return trip_items?.id === trip_id ? trip_items : null;
  }
);
